"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _utils = require("./utils");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
/* eslint-disable max-len */

var UserStatusIconDoNotDisturb = /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("circle", {
  className: "presence-border",
  cx: "7",
  cy: "7",
  r: "7",
  fill: "white"
}), /*#__PURE__*/_react["default"].createElement("circle", {
  cx: "7",
  cy: "7",
  r: "5",
  fill: "#CB2233"
}), /*#__PURE__*/_react["default"].createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3.25 7C3.25 6.58579 3.58579 6.25 4 6.25H10C10.4142 6.25 10.75 6.58579 10.75 7C10.75 7.41421 10.4142 7.75 10 7.75H4C3.58579 7.75 3.25 7.41421 3.25 7Z",
  fill: "white"
}));
var _default = (0, _utils.createSvgIcon)(UserStatusIconDoNotDisturb);
exports["default"] = _default;